import { GameConstants } from "../../GameConstants";
import { Button } from "../../utils/Button";
import { GameVars } from "../../GameVars";
import { HiLoManager } from "../../managers/HiLoManager";
import { AudioManager } from "../../managers/AudioManager";

export class InfoLayerHiLo extends Phaser.GameObjects.Container {

    public titleLabel: Phaser.GameObjects.Text;

    constructor(scene: Phaser.Scene) {

        super(scene);

        const background = new Phaser.GameObjects.Graphics(this.scene);
        background.fillStyle(0x000000, .75);
        background.fillRect(0, 0, GameConstants.GAME_WIDTH, GameConstants.GAME_WIDTH);
        this.add(background); 

        const instructionsContainer = new Phaser.GameObjects.Container(this.scene);
        instructionsContainer.x = GameConstants.GAME_WIDTH / 2;
        instructionsContainer.scaleX = GameVars.scaleX;
        this.add(instructionsContainer);

        const instructionsTitle = new Phaser.GameObjects.Text(this.scene, 0, 5, "HIGH OR LOW RULES", {fontFamily: "Oswald-Medium", fontSize: "46px",  wordWrap: { width: 600, useAdvancedWrap: true}, color: "#ffffff"});
        instructionsTitle.setOrigin(.5, 0);
        instructionsContainer.add(instructionsTitle); 

        let instructionsStr = "A set of 10 cards from ACE to KING are shuffled and piled on the right. After a card from the piles is revealed you have to guess if the next card revealed will have either a higher or lower value.";

        let instructionsLabel = new Phaser.GameObjects.Text(this.scene, 0, 100, instructionsStr, {fontFamily: "Oswald-Medium", fontSize: "30px",  wordWrap: { width: 820, useAdvancedWrap: true}, color: "#ffffff", align: "center"});
        instructionsLabel.setOrigin(.5, 0);
        instructionsContainer.add(instructionsLabel); 

        const instructionsImage = new Phaser.GameObjects.Image(this.scene, 0, 300, "texture_atlas_1", "card_values_hilo.png");
        instructionsContainer.add(instructionsImage); 

        instructionsStr = "The SCORE value will be added to your CREDITS if you end the right pile of cards keeping all 3 LIVES (hearts).";

        instructionsLabel = new Phaser.GameObjects.Text(this.scene, 50, 370, instructionsStr, {fontFamily: "Oswald-Medium", fontSize: "30px",  wordWrap: { width: 540, useAdvancedWrap: true}, color: "#ffffff", align: "center"});
        instructionsLabel.setOrigin(.5, 0);
        instructionsContainer.add(instructionsLabel); 

        instructionsStr = "You can recover a LIFE if you guess correctly 5 cards in a row (WIN STREAK).";

        instructionsLabel = new Phaser.GameObjects.Text(this.scene, 50, 510, instructionsStr, {fontFamily: "Oswald-Medium", fontSize: "30px",  wordWrap: { width: 540, useAdvancedWrap: true}, color: "#ffffff", align: "center"});
        instructionsLabel.setOrigin(.5, 0);
        instructionsContainer.add(instructionsLabel); 

        const closeButton = new Button(this.scene, GameConstants.GAME_WIDTH - 5 * GameVars.scaleX,  GameConstants.GAME_HEIGHT - 5 * GameVars.scaleX, "texture_atlas_1", "btn_close.png", "btn_close.png", true, true);
        closeButton.scaleX = GameVars.scaleX;
        closeButton.setOrigin(1);
        closeButton.onUp(this.onClickCLose, this);
        this.add(closeButton); 

        const banana = new Phaser.GameObjects.Image(this.scene, 140 * GameVars.scaleX, GameConstants.GAME_HEIGHT - 150, "texture_atlas_1", "banana-tutorial.png");
        banana.scaleX = GameVars.scaleX;
        this.add(banana);
    }

    private onClickCLose(): void {

        AudioManager.playSound("btn_click");

        HiLoManager.hideInfoLayer();
    }
}
